import { render } from "./UnidadePage.vue?vue&type=template&id=b1f3d2d8&scoped=true"
import script from "./UnidadePage.vue?vue&type=script&lang=js"
export * from "./UnidadePage.vue?vue&type=script&lang=js"

import "./UnidadePage.vue?vue&type=style&index=0&id=b1f3d2d8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1f3d2d8"]])

export default __exports__